<div class="card shadow border-0 mb-3 tab-pane fade fade-in-zoom active show" role="tabpanel">
  <div class="card-header fw-bold bg-tertiary p-3 border-0 d-flex justify-content-between align-items-center">
    <h2 class="fs-6 fw-bold mb-0">
      <i class="bi bi-database-gear me-2 text-primary"></i>Custom Payouts
    </h2>
  </div>

  <div class="card-body">

    @if (!loader.isLoading()) {
      <form [formGroup]="form" (ngSubmit)="submit()">
        <div class="row g-3">
          <div class="col-4">
            <label for="name" class="form-label fw-bold small">Name</label>
            <div class="input-group">
              <span class="input-group-text"><i class="bi bi-tag"></i></span>
              <input type="text" class="form-control" id="name" formControlName="name">
            </div>
          </div>
          <div class="col-4">
            <label for="startingAt" class="form-label fw-bold small">Effective date</label>
            <div class="input-group">
              <span class="input-group-text"><i class="bi bi-calendar"></i></span>
              <input type="date" class="form-control" id="startingAt" formControlName="startingAt">
            </div>
          </div>
          <div class="col-4 pt-4">
            <app-input-switch formControlName="enabled">Enabled</app-input-switch>
          </div>
        </div>
        <div class="row g-3">
          <div class="col-6">
            <label for="goal" class="form-label fw-bold small">Goal</label>
            <select class="form-select" formControlName="goalId" id="goal" (change)="changeGoal()">
              <option [value]=null>Choose a Goal</option>
              @for (goal of goals; track goal) {
                <option [value]="goal.id">{{ goal }}</option>
              }
            </select>
          </div>
          <div class="col-6">
            <label for="goalType" class="form-label fw-bold small">Goal type</label>
            <select class="form-select" formControlName="goalTypeId" id="goalType" [appElementLoader]="goalTypesLoading">
              <option [value]=null>All goal types</option>
              @for (goalType of goalTypes; track goalType) {
                <option [value]="goalType.id">{{ goalType }}</option>
              }
            </select>
          </div>
        </div>
        <div class="row g-3">
          <div class="col-3">
            <label for="payout-amount" class="form-label fw-bold small">Payout Amount</label>
            <div class="input-group">
              <span class="input-group-text"><i class="bi bi-cash"></i></span>
              <input type="text" class="form-control" id="payout-amount" formControlName="payoutAmount">
            </div>
          </div>
          <div class="col-3">
            <label for="payout-currency" class="form-label fw-bold small">Payout Currency</label>
            <div class="input-group">
              <span class="input-group-text"><i class="bi bi-currency-exchange"></i></span>
              <select id="currency" class="form-select" formControlName="currencyId">
                <option [ngValue]="null">Default currency</option>
                @for (currency of currencies; track currency) {
                  <option [ngValue]="currency.id">{{ currency }}</option>
                }
              </select>
            </div>
          </div>
          <div class="col-6">
            <label for="payout-percent" class="form-label fw-bold small">Payout Percent</label>
            <div class="input-group">
              <span class="input-group-text"><i class="bi bi-percent"></i></span>
              <input type="text" class="form-control" id="payout-percent" formControlName="payoutPercent">
            </div>
          </div>
        </div>
        <div class="row g-3 mt-5">
          <div class="col-6">
            <div class="row">
              <div class="col-auto">
                <h3>Sub ID@if (form.value && form.value.subIds) {
                  <span> ({{ form.value.subIds.length }})</span>
                }</h3>
              </div>
              <div class="col-auto">
                <input #subId type="text" class="form-control" placeholder="Sub ID" style="width: 200px;">
              </div>
              <div class="col-auto">
                <button (click)="addSubId(subId)" type="button" class="btn btn-primary fw-bold"><i
                class="bi bi-plus me-2"></i>Add
              </button>
            </div>
          </div>
          <div class="row">
            <div class="col" formArrayName="subIds">
              <table class="table">
                <thead>
                  <tr>
                    <th>SubId</th>
                    <th class="text-end">Action</th>
                  </tr>
                </thead>
                <tbody>
                  @for (subIdControl of subIdsControls; track subIdControl; let i = $index) {
                    <tr [formGroup]="subIdControl">
                      <td>{{ subIdControl.value?.subId }}</td>
                      <td class="text-end">
                        <button (click)="subIdsArray.removeAt(i)" type="button" class="btn btn-primary btn-sm fw-bold">Remove
                        </button>
                      </td>
                    </tr>
                  }
                </tbody>
              </table>
            </div>
          </div>
        </div>
        <div class="col-6">
          <div class="row">
            <div class="col-auto">
              <h3>Offers@if (form.value && form.value.offers) {
                <span> ({{ form.value.offers.length }})</span>
              }</h3>
            </div>
          </div>
          <div class="row g-2 align-items-center mb-2">
            <div class="col-4">
              <div class="input-group">
                <span class="input-group-text"><i class="bi bi-box-seam"></i></span>
                <app-dropdown-select [(ngModel)]="productFilterId" [ngModelOptions]="{standalone: true}"
                  (ngModelChange)="changeProductFilter()">
                  <app-dropdown-select-option [value]="null">All products</app-dropdown-select-option>
                  @for (product of products; track product.id) {
                    <app-dropdown-select-option [value]="product.id">{{ product }}</app-dropdown-select-option>
                  }
                </app-dropdown-select>
              </div>
            </div>
            <div class="col">
              <div class="input-group">
                <span class="input-group-text"><i class="bi bi-megaphone"></i></span>
                <app-dropdown-select [(ngModel)]="selectedOfferId" [ngModelOptions]="{standalone: true}"
                  placeholder="Choose an offer">
                  @for (offer of getAvailableOffers(); track offer.id) {
                    <app-dropdown-select-option [value]="offer.id">{{ offer }}</app-dropdown-select-option>
                  }
                </app-dropdown-select>
              </div>
            </div>
            <div class="col-auto">
              <button (click)="addOffer()" type="button" class="btn btn-primary fw-bold" [disabled]="!selectedOfferId"><i
              class="bi bi-plus me-2"></i>Add
            </button>
          </div>
        </div>
        <div class="row">
          <div class="col" formArrayName="offers">
            <table class="table">
              <thead>
                <tr>
                  <th>Offer</th>
                  <th class="text-end">Action</th>
                </tr>
              </thead>
              <tbody>
                @for (offerControl of offersControls; track offerControl; let i = $index) {
                  <tr [formGroup]="offerControl">
                    <td>{{ getOfferName($safeNavigationMigration(offerControl.value?.offerId)) }}</td>
                    <td class="text-end">
                      <button (click)="offersArray.removeAt(i)" type="button" class="btn btn-primary btn-sm fw-bold">Remove
                      </button>
                    </td>
                  </tr>
                }
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
    <div class="row mt-3">
      <div class="col-12 text-end">
        <button type="submit" class="btn btn-primary fw-bold">Update</button>
      </div>
    </div>
  </form>
}

</div>
</div>
